"use client";

import { ChipClose, ChipLabel, ChipRoot } from "@dafiti/closet-ui";
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";

import { useFilteredItems } from "../../../hooks/useFilteredItems.hook";
import { useLiveUpdate } from "../../../hooks/useLiveUpdate.hook";
import { useFiltersStore } from "../../../stores/filters.store";
import { parseCatalogRoute } from "../../../types/catalogRoute.helper";

export function FilteredItemsSection() {
  const t = useTranslations("catalog");
  const chips = useFilteredItems();
  const pathname = usePathname();
  const removePendingFilter = useFiltersStore((s) => s.removePendingFilter);
  const updatePendingFilter = useFiltersStore((s) => s.updatePendingFilter);
  const { triggerLiveUpdate } = useLiveUpdate();

  // Em /c e /b a categoria é navegada por path. Remover só o chip da categoria
  // não altera o path, então o X é ocultado para esse chip nessas rotas.
  const { isCategoryDrill } = parseCatalogRoute(pathname);

  const handleRemove = (field: string, value: string) => {
    if (field === "price") {
      updatePendingFilter("price_min", null);
      updatePendingFilter("price_max", null);
    } else if (field === "pending_category_path") {
      updatePendingFilter("pending_category_path", undefined);
    } else {
      removePendingFilter(field, value);
    }
    triggerLiveUpdate();
  };

  return (
    <section
      className="flex flex-col gap-3xs"
      aria-label={t("results.appliedFiltersLabel")}
    >
      <span className="text-body-2 text-black font-medium">
        {t("results.filteredItemsTitle")}
      </span>

      {chips.length > 0 && (
        <div className="flex gap-quark overflow-x-auto pb-nano scrollbar-none">
          {chips.map((chip) => {
            const isLockedCategory =
              isCategoryDrill && chip.field === "pending_category_path";

            return (
              <ChipRoot key={`${chip.field}-${chip.value}`} size="md">
                <ChipLabel className={isLockedCategory ? "first:pr-[6px]" : ""}>
                  {chip.label}
                </ChipLabel>
                {!isLockedCategory && (
                  <ChipClose
                    onRemove={() => handleRemove(chip.field, chip.value)}
                    removeAriaLabel={t("actions.removeFilter", {
                      filterName: chip.label,
                    })}
                  />
                )}
              </ChipRoot>
            );
          })}
        </div>
      )}
    </section>
  );
}
